module.exports = __webpack_public_path__ + "assets/img/58@3x.0fa196d7.png";